import type { ResolvedGlobalPageSettings } from '~/lib/ContentfulGraphqlService';
import { useGlobalPageSettings } from '~/composables/useGlobalPageSettings';

export default defineNuxtPlugin({
  name: 'globalPageSettings',
  enforce: 'pre',
  async setup() {
    const { $locale } = useNuxtApp();
    const globalPageSettings = useState<ResolvedGlobalPageSettings | null>(
      'globalPageSettings'
    );
    const protectedSlugs = useState<string[]>('protectedSlugs');

    if (!globalPageSettings.value) {
      globalPageSettings.value = (
        await useGlobalPageSettings($locale.value)
      ).value;
    }

    return {
      provide: {
        globalPageSettings,
        protectedSlugs
      }
    };
  }
});
